import { useEffect } from "react";
import { CGUContent } from "@/components/CGUContent";

export default function CGUPage() {
  useEffect(() => window.scrollTo(0, 0), []);
  return (
    <div data-testid="cgu-page" className="max-w-3xl mx-auto px-4 sm:px-8 py-16">
      <h1 className="font-display font-extrabold text-4xl sm:text-5xl text-emerald-950 mb-2">Conditions Générales d'Utilisation</h1>
      <p className="text-sm text-slate-500 mb-10">Dernière mise à jour : juin 2026</p>
      <CGUContent />
    </div>
  );
}
